import { render, staticRenderFns } from "./variety.vue?vue&type=template&id=78f8b4f7&scoped=true&"
import script from "./variety.vue?vue&type=script&lang=js&"
export * from "./variety.vue?vue&type=script&lang=js&"
import style0 from "./variety.vue?vue&type=style&index=0&id=78f8b4f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f8b4f7",
  null
  
)

export default component.exports